import { Component } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { TranslatePipe } from "@ngx-translate/core";
import { SnackbarComponent } from "../snackbar.component";

@Component({
  standalone: true,
  selector: "app-info-message",
  imports: [MatIconModule, TranslatePipe],
  templateUrl: "./info-message.component.html",
  styleUrl: "./info-message.component.less",
})
export class InfoMessageComponent extends SnackbarComponent<string> {
  public constructor() {
    super();
  }
}
